import { useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../auth'

export const PaymentDue = () => {
  const { formatMessage } = useIntl()
  const navigate = useNavigate()
  const { invoiceStatus } = useAuth()

  if (invoiceStatus !== 'payment_due') return null

  return (
    <div id="kt_app_wrapper" className='app-wrapper flex-column flex-row-fluid bg-warning bg-opacity-10 d-flex align-items-center justify-content-center gap-2' style={{ padding: '4px' }}>
      <p className='font-size-11 m-0 text-dark text-center'
      >
        {formatMessage({
          id: 'Your recent payment attempt failed. Please update your payment method to avoid service disruption.',
        })}
        <button
          className='border-0 bg-transparent text-primary font-size-11'
          onClick={() => navigate('/setting/billing-invoice?tab=billing')}
        >
          {formatMessage({ id: 'Update Now' })}
        </button>
      </p>
    </div>
  )
}
